import React from 'react'
import Router from './pages/Router'

const App = () => {
    return (
        <Router/>
    )
}

export default App
